import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import admin from "../../services/adminService";

const CommingSoon = () => {
  const [socialLink, setSocialLink] = useState([]);
  const [timespan, setTimespan] = useState({
    end: "Oct 15, 2020 12:00:00",
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });
  let startTimer = () => {
    let countDownDate = new Date(timespan.end).getTime();
    let currentTime = new Date().getTime();

    let timer = countDownDate - currentTime;
    if (timer >= 0) {
      let days = Math.floor(timer / 1000 / 60 / 60 / 24);
      let hours = Math.floor(timer / 1000 / 60 / 60 - days * 24);
      let minutes = Math.floor(timer / 1000 / 60 - hours * 60 - days * 1440);
      let seconds = Math.floor(
        timer / 1000 - minutes * 60 - hours * 3600 - days * 86400
      );
      // let milliSeconds = Math.floor(
      //   timer -
      //     seconds * 1000 -
      //     minutes * 60000 -
      //     hours * 3600000 -
      //     days * 86400000
      // );
      setTimespan({
        days: leadingZero(days),
        hours: leadingZero(hours),
        minutes: leadingZero(minutes),
        seconds: leadingZero(seconds),
      });
    }
  };
  let leadingZero = (time) => {
    if (time <= 9) {
      return "0" + time;
    } else {
      return time;
    }
  };
  useEffect(() => {
    let socialLink = admin.getSocialLink();
    setSocialLink(socialLink);
    setInterval(startTimer, 1000);
  }, [timespan]);

  return (
    <section className="mt-5 comming-soon">
      <div className="min-vh-100 ">
        <div className="container h-100 d-flex justify-content-center align-items-center">
          <div className="row pt-1 mt-1">
            <div className="col-md-12 mb-3">
              <div className="text-center">
                <ul className="list-unstyled ">
                  <li>
                    <h1 className="display-3 mt-md-5 mt-lg-5 mb-2 pt-3 font-weight-bold">
                      <strong>COMING SOON</strong>
                    </h1>
                  </li>
                  <li>
                    <h4 className=" description mb-3 font-weight-bolder">
                      Please stay tuned!
                    </h4>
                    {socialLink.map((social) => (
                      <a
                        type="button"
                        key={social.label}
                        aria-label={social.label}
                        rel="noopener noreferrer"
                        href={social.href}
                        target="_blank"
                        className="btn-floating btn-small bg-light"
                      >
                        <i className={social.icon + " " + social.color}></i>
                      </a>
                    ))}
                  </li>
                </ul>

                <div
                  className="row text-center justify-content-center align-items-center"
                  id="countdown"
                >
                  <div className="">
                    <h1 className="display-4 font-weight-bold p-1">
                      <strong id="count-days">{timespan.days}</strong>
                    </h1>
                    <p className="font-weight-bold spacing pt-2">DAYS</p>
                  </div>

                  <div className="">
                    <h1 className="display-4 font-weight-bold rgba-white-strong mx-2 p-1">
                      <strong id="count-hours">{timespan.hours}</strong>
                    </h1>
                    <p className="font-weight-bold spacing pt-2">HOURS</p>
                  </div>

                  <div className="">
                    <h1 className="display-4 font-weight-bold p-1">
                      <strong id="count-minutes">{timespan.minutes}</strong>
                    </h1>
                    <p className="font-weight-bold spacing pt-2">MINS</p>
                  </div>

                  <div className="">
                    <h1 className="display-4 font-weight-bold rgba-white-strong mx-2 p-1">
                      <strong id="count-seconds">{timespan.seconds}</strong>
                    </h1>
                    <p className="font-weight-bold spacing pt-2">SECONDS</p>
                  </div>
                </div>
                <p className="description title pb-5 font-weight-bolder">
                  The page you're looking for is under construction, Please try
                  later or back to
                  <Link to="/" className="font-weight-bold orange-text">
                    {" "}
                    Home
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommingSoon;
